import React, { Component, lazy } from 'react';
import './Category.sass';
import i18n from '../../../../../i18n';
import Config from '../../../../../base/config/Config';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import DataArray from '../../../../../base/config/DataArray';
import LazyLoad from 'react-lazyload';
const Title = lazy(() => import('../../../../component/title/Title'));
const AnimateCollapse = lazy(() => import('../../../../component/animateCollapse/AnimateCollapse'));
const Message = lazy(() => import('./../../../../component/message/Message'));
const Button = lazy(() => import('../../../../component/button/Button'));

class Category extends Component {
    constructor(props) {
        super(props);
        this.state = { active: 0, style: {}, iconStyle: { top: '0px' }, imageTop: { marginTop: '0px' } };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (JSON.stringify(this.state) !== JSON.stringify(nextState)) {
            return true;
        }
        return false;
    }

    handleActive = (active, target) => {
        var iconTop = (active * 7);
        var imageTop = (active * 80);

        const x = 0;
        const y = -1140 * active;
        var top = 0;
        setTimeout(() => { this.setState({ style: { transform: `translate(${x}px, ${y}px)` }, iconStyle: { top: `${iconTop}%` }, imageTop: { marginTop: `${imageTop}px` }, active: active }); top = target.getBoundingClientRect().top + document.documentElement.scrollTop - 116; }, 40);
        setTimeout(() => {
            window.scrollTo({ top: top, behavior: 'smooth' });
        }, 60);
    }


    render() {
        var currentLanguage = Cookies.get('currentLanguage');

        var dataArray = DataArray.categories.filter((category) => !category.removeCategory);

        var categories = dataArray[this.state.active].categories;

        var message = i18n.t('We are commited to be your partner on this journey giving you the best solutions for your day-to-day on social media. Count us in to _grow_, to _impact_ and to do _different_ on social media.');

        var startText;
        var endText;
        var text_to_get;

        while (message.includes('_')) {
            startText = message.indexOf('_') + 1;
            endText = message.indexOf('_', startText);
            text_to_get = message.substring(startText, endText);

            message = message.replace(`_${text_to_get}_`, `<span class = "Underline" >${text_to_get}</span>`);
        }

        var someHtml = ` ${message} `;

        return (
            <div className="categoryArea">
                <div className="categoryMessageArea">
                    <div className="categoryTitle">
                        <Title size="Big" type="Secundary" text={i18n.t('One powerful solution for winners on social media')} />
                    </div>
                    <div className="categoryMessage">
                        <Message size="Bigger" type="Secundary" html={someHtml} text="" />
                    </div>
                </div>
                <div className="categoryImageArea" >
                    {dataArray.map((category, key) => {
                        return (
                            <div className={`categoryImageAndIconArea ${this.state.active === key ? 'active' : null}`} style={this.state.style} key={key}>
                                <div className="categoryImage">
                                    <div className="categoryIconArea" style={this.state.iconStyle}>
                                        <LazyLoad offset={200} height={60}>
                                            <img alt={key} src={category.icon} />
                                        </LazyLoad>
                                    </div>
                                    <LazyLoad offset={200} height={600}>
                                        <img style={this.state.imageTop} alt={key} src={category.image} />
                                    </LazyLoad>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="categoryCollapseArea">
                    <AnimateCollapse dataArray={dataArray} onSelectActive={this.handleActive} >
                        <div className="categoryContentTextArea">
                            <Message type="Secundary" size="Big" text={dataArray[this.state.active].message} />
                        </div>
                        <div className="categoryContentCategoryArea">
                            {categories.map((category, key) => {
                                return (
                                    <div key={key} className="categoryContentCategory">
                                        <div className="categoryContentCategoryDot" />
                                        <div className="categoryContentCategoryText">
                                            <Message size="Big" type="Secundary" text={category.message} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="categoryContentButtonArea">
                            <a href={`${Config.appHost}register?utm_source=website&utm_medium=homepage&utm_campaign=cta-3-${dataArray[this.state.active].href}`}> <Button type="Primary" size="Small" text={i18n.t('I Want to Start now')} /> </a>
                            <Link to={`/${currentLanguage}/solutions/${dataArray[this.state.active].href}`} > <Button type="UnderlineTransparentSecundary" size="Small" text={i18n.t('I’d like to know more')} /> </Link>
                        </div>
                    </AnimateCollapse>
                </div>

                <div className="categorySmallArea">
                    {dataArray.map((category, key) => {
                        var icon = category.icon;

                        var image = '';

                        if (category.image === '')
                            image = '';
                        else
                            image = category.image;

                        return <div key={key}>
                            <div className="categorySmallImageArea">
                                <LazyLoad offset={200} height={600}>
                                    <img src={image} alt="categoryImage" />
                                </LazyLoad>
                            </div>
                            <div className="categorySmallTextArea">
                                <div className="categorySmallTitleArea">
                                    <div className="categorySmallTitleTop">
                                        <div className="categorySmallIconArea">
                                            <LazyLoad offset={200} height={60}>
                                                <img alt={key} src={icon} />
                                            </LazyLoad>
                                        </div>
                                        <div className="categorySmallTitle">
                                            <Title size="Medium" type="Secundary" text={category.text} />
                                            <div className="categorySmallLine" />
                                        </div>
                                    </div>
                                </div>
                                <div className="categorySmallMessageArea">
                                    <Message size="Big" type="Secundary" text={category.message} />
                                </div>
                            </div>
                            <div className="categoryContentCategoryArea">
                                {category.categories.map((category, key) => {
                                    return (
                                        <div key={key} className="categoryContentCategory">
                                            <div className="categoryContentCategoryDot" />
                                            <div className="categoryContentCategoryText">
                                                <Message size="Big" type="Secundary" text={category.message} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="categorySmallButtonArea">
                                <a href={`${Config.appHost}register`}> <Button type="Primary" size="Small" text={i18n.t('I Want to Start now')} /> </a>
                                <Link to={`/${currentLanguage}/solutions/${dataArray[this.state.active].href}`} >  <Button type="UnderlineTransparentSecundary" size="Small" text={i18n.t('I’d like to know more')} /> </Link>
                            </div>
                        </div>;
                    })}
                </div>
            </div>
        );
    }
}

export default Category;
